import React from 'react';
import { Chip, withStyles } from '@material-ui/core';

const styles = {
  chip: {
    margin: 4,
  },
};

// Function to determine chip color based on status
const getChipColors = (status) => {
  switch (status) {
    case 'Inventory Pending':
      return {
        backgroundColor: '#FFF3E0', // Light orange
        color: '#EF6C00', // Dark orange
      };
    case 'Processing Inventory':
      return {
        backgroundColor: '#E3F2FD', // Light blue
        color: '#1565C0', // Dark blue
      };
    case 'Unable To Access':
      return {
        backgroundColor: '#FFEBEE', // Light red
        color: '#C62828', // Dark red
      };
    case 'Inventory Complete':
      return {
        backgroundColor: '#E8F5E9', // Light green
        color: '#2E7D32', // Dark green
      };
    default:
      return {
        backgroundColor: '#EEEEEE', // Default grey
        color: '#424242', // Dark grey
      };
  }
};

const AuthorizationStatusChip = ({ status, classes }) => {
  const chipStyle = getChipColors(status);

  return (
    <Chip
      label={status}
      className={classes.chip}
      style={{
        ...chipStyle,
      }}
    />
  );
};

export default withStyles(styles)(AuthorizationStatusChip);